import * as MenuPrimitive from '@radix-ui/react-dropdown-menu'
import type { PropsWithChildren } from 'react'
import { forwardRef } from 'react'

import type { DropdownContentProps, DropdownTriggerProps } from './types'
import {
  DropdownMenuContent as StyledDropdownMenuContent,
  DropdownMenuSubtitle,
  DropdownMenuTitle,
  DropdownMenuItem,
} from './DropdownMenu.styled'

function DropdownMenu({
  children,
  ...rest
}: PropsWithChildren<MenuPrimitive.DropdownMenuProps>) {
  return <MenuPrimitive.Root {...rest}>{children}</MenuPrimitive.Root>
}

function Content({
  children,
  sideOffset = 6,
  elevation,
  ...rest
}: PropsWithChildren<DropdownContentProps>) {
  return (
    <StyledDropdownMenuContent
      loop
      sideOffset={sideOffset}
      $elevation={elevation}
      {...rest}
    >
      {children}
    </StyledDropdownMenuContent>
  )
}

const Trigger = forwardRef<
  HTMLButtonElement,
  PropsWithChildren<DropdownTriggerProps>
>(function Trigger({ children, ...rest }, ref) {
  return (
    <MenuPrimitive.Trigger asChild ref={ref} {...rest}>
      {children}
    </MenuPrimitive.Trigger>
  )
})

DropdownMenu.Trigger = Trigger
DropdownMenu.Content = Content
DropdownMenu.Item = DropdownMenuItem
DropdownMenu.Title = DropdownMenuTitle
DropdownMenu.Subtitle = DropdownMenuSubtitle

export default DropdownMenu
